<div id="layout-wrapper">
    <!-- Top bar -->
    <app-horizontaltopbar (mobileMenuButtonClicked)="onToggleMobileMenu()" (settingsButtonClicked)="onSettingsButtonClicked()"></app-horizontaltopbar>

    <!-- Overlay móvil: toca fuera para cerrar el menú -->
    <div class="topnav-overlay" (click)="closeMobileMenu()"></div>

    <!-- Botón X para cerrar el menú en móvil -->
    <button class="topnav-close-btn" (click)="closeMobileMenu()" aria-label="Cerrar menú">&times;</button>

    <div class="main-content">
        <div class="page-content">
            <div class="container-fluid">
                <!-- content -->
                <router-outlet></router-outlet>
            </div>
        </div>
        <!-- footer -->
        <app-footer></app-footer>
    </div>
</div>
<app-rightsidebar></app-rightsidebar>